import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Drawer from '@mui/material/Drawer';
import Select from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import DatePicker, { DateObject } from "react-multi-date-picker";
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";
import AddItemSch from './../../../../modal/Production_Management/Manage_Items/AddItemSch';
import EditItemSch from './../../../../modal/Production_Management/Manage_Items/EditItemSch';
import Edit from './../../../../modal/Production_Management/Manage_Items/EditItemSch';
import axios from 'axios'; // new

const ItemSchedule = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const tableRef = useRef(null);
    const [key, setKey] = useState('item_schedule');
    const handleModal_editsch = () => {
        setModalType("EditItemSch");
        setOpen(true);
    };
    const handleModal_addsch = () => {
        setModalType("AddItemSch");
        setOpen(true);
    };

    const [editModalShow, setEditModalShow] = useState(false);
    const [currentItemId, setCurrentItemId] = useState(null);
    const handleModaleditsch = (scheduleId) => {
        setEditModalShow(true);
        setCurrentItemId(scheduleId);
    };

    const DeleteModal = (scheduleId, scheduleName) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Item Schedule
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${scheduleName}</b></p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // 🔥 Call DELETE API
                axios.delete(`${baseURL}/item-schedule/${scheduleId}`)
                    .then(() => {
                        swal.fire({
                            title: 'Schedule Deleted!',
                            text: `${scheduleName} has been marked as deleted.`,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(() => {

                            softRefresh();
                        });
                    })
                    .catch((error) => {
                        console.error("Delete failed:", error);
                        swal.fire({
                            title: 'Error!',
                            text: 'Something went wrong while deleting.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                title: 'fs-6',
                                confirmButton: 'btn btn-sm btn-primary',
                            },
                        });
                    });
            } else {
                swal.fire({
                    title: 'Delete Cancelled',
                    text: `${scheduleName} was not deleted.`,
                    icon: 'info',
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                });
            }
        });
    };

    const [itemSchedule, setitemSchedule] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchitemSchedule();
    }

    const fetchitemSchedule = () => {
        axios.get(`${baseURL}/item-schedule`)
            .then(response => {
                const data = response.data;
                if (Array.isArray(data)) {
                    setitemSchedule(data);
                    setHasFetched(true);
                } else if (Array.isArray(data?.data)) {
                    setitemSchedule(data.data);
                    setHasFetched(true);
                } else {
                    console.warn("Unexpected response format:", data);
                    setitemSchedule([]);
                    setHasFetched(true);
                }
            })
            .catch(error => {
                console.error("Error fetching schedule:", error);
                setitemSchedule([]);

            });
    };

    useEffect(() => {
        fetchitemSchedule();
    }, []);

    useEffect(() => {
        let dataTableInstance;

        if (itemSchedule.length > 0 && tableRef.current) {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().clear().destroy(); // ✅ Safe cleanup
            }

            dataTableInstance = $(tableRef.current).DataTable({
                // responsive: true,
                // ordering: false,
                destroy: true,
                responsive: true,
                pageLength: 10,
                ordering: false,
                language: {
                    "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                },
                dom:
                    "<'row'" +
                    "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                    "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                    ">" +
                    "<'table-responsive'tr>" +
                    "<'row'" +
                    "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                    "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                    ">"
            });
        }

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy(); // ✅ Cleanup on unmount
            }
        };
    }, [itemSchedule]);

    const [itemcategoryCount, setItemCategoryCount] = useState(0); // used for item category count
    const [itemsubcategoryCount, setItemSubCategoryCount] = useState(0);  // used for item sub category data
    const [itemCount, setItemCount] = useState(0);  // used for item data
    const [itemScheduleCount, setItemScheduleCount] = useState(0);
    useEffect(() => {
        axios.get(`${baseURL}/item-categories`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemCategoryCount(data.pagination?.total);
                } else {
                    setItemCategoryCount(0);
                }
            })
            .catch(error => {
                console.error("Error fetching item categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-subcategories`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemSubCategoryCount(data.pagination?.total);
                } else {
                    setItemSubCategoryCount(0);
                }
            })
            .catch(error => {
                console.error("Error fetching item sub categories:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemSubCategoryCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/manage-items`)
            .then(response => {
                const data = response.data;

                if(data.pagination){
                    setItemCount(data.pagination?.total);
                } else {
                    setItemCount(0);
                }
            })
            .catch(error => {
                console.error("Error fetching item:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    useEffect(() => {
        axios.get(`${baseURL}/item-schedule`)
            .then(response => {
                const data = response.data;

                // Check if the response contains product categories correctly
                if (Array.isArray(data)) {
                    // setProductCategories(data);  // Set the product categories list
                    setItemScheduleCount(data.length);  // Set category count based on the array length
                } else if (Array.isArray(data?.data)) {
                    // setProductCategories(data.data);  // Set product categories if nested in 'data'
                    setItemScheduleCount(data.data.length);  // Set category count based on the nested array
                } else {
                    console.warn("Unexpected response format for schedule:", data);
                    // setProductCategories([]);  // Default to an empty list
                    setItemScheduleCount(0);  // Default to 0 in case of unexpected response
                }
            })
            .catch(error => {
                console.error("Error fetching item schedule:", error);
                // setProductCategories([]);  // Default to an empty list in case of error
                setItemScheduleCount(0);  // Default to 0 in case of error
            });
    }, []);  // Only run once on mount

    const handleStatusChange = (scheduleId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;

        axios.put(`${baseURL}/item-schedule/status/${scheduleId}`, { status: newStatus })
            .then(() => {
                fetchitemSchedule();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.log("Error updating status:", error);
                toast.error("Status Updation Failed");
            });
    };

    const handleAddSuccess = () => {
        console.log("Add success called!");
        toast.success("Schedule added Successfully!");
        setOpen(false);
        softRefresh();
    };

    const [languages, setLanguages] = useState([]);  // Store languages 
    const [languageCode, setLanguageCode] = useState();
    useEffect(() => {
        axios
            .get(`${baseURL}/language/active/list`) // API endpoint to fetch active languages
            .then((response) => {
                // Assuming response.data.data is an array of languages
                setLanguages(response.data.data || []);
            })
            .catch((error) => {
                console.error("Error fetching languages:", error);
            });
    }, []);

    const handleLanguageChange = (newLangCode) => {
        setLanguageCode(newLangCode); // Set the selected language code

        // Fetch categories based on new language code
        axios
            .get(`${baseURL}/item-schedule`, {
                params: {
                    language_code: newLangCode,
                },
            })
            .then((response) => {
                setitemSchedule(response.data.data || []);
                setHasFetched(true);
            })
            .catch((error) => {
                console.error(`Error fetching item categories with language_code=${newLangCode}:`, error);
            });
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Items</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Package Management</li>
                    </ol>
                </div>

                <div className='d-flex align-items-center gap-3 mb-2'>

                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            variant="primary"
                            className="btn btn-primary text-white btn-sm"
                            id="tp-btn"
                        >
                            <span className="me-2">
                                <i className="fa-solid fa-globe mt-1 fs-3 px-0 py-0"></i>
                            </span>
                            {languages.find((lang) => lang.language_code === languageCode)?.language_name}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {languages.map((lang) => (
                                <Dropdown.Item
                                    key={lang.language_code}
                                    href="#"
                                    className="px-0 py-2"
                                    onClick={() => handleLanguageChange(lang.language_code)}
                                >
                                    <span className="fs-7 ms-2 font-w500 text-black">{lang.language_name}</span>
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>

                </div>

                {open && modalType === "AddItemSch" && (
                    <AddItemSch show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} />
                )}

                {open && modalType === "EditItemSch" && (
                    <EditItemSch show={open} onClose={() => setOpen(false)} />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs mb-4">
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/manage-items" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-bowl-rice me-3" />
                                        <label className="fs-6">
                                            Items
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/item-category" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-kitchen-set me-3" />
                                        <label className="fs-6">
                                            Item Category
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemcategoryCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link >
                                    <Link to="/item-sub-category" className="d-flex align-items-center text-decoration-none">
                                        <i className="fa-solid fa-plate-wheat me-3" />
                                        <label className="fs-6">
                                            Item Sub Category
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemsubcategoryCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="item_schedule">
                                    <Link to="/item-schedule" className="d-flex align-items-center text-decoration-none">
                                        <svg className="me-2" width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 8V12L14.5 14.5" stroke="#025d3a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#025d3a" stroke-width="1.5"></path> </g></svg>
                                        <label className="fs-6">
                                            Item Schedule
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {String(itemScheduleCount).padStart(2, '0')}
                                        </Badge>
                                    </Link>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="item_schedule">
                                <Row>

                                    <Col xl={12} className='mb-3 d-flex align-items-end justify-content-end gap-3'>
                                        <Link to={"#"} className="btn btn-primary float-end btn-sm mb-2" onClick={handleModal_addsch}>
                                            <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                                            <span className=''>Add Item Schedule</span>
                                        </Link>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table ref={tableRef} id="kt_datatable_responsive_approved" className="item_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-100px'>Item Schedule</th>
                                                        <th className='min-w-100px'><OverlayTrigger
                                                            trigger={['hover', 'focus']}
                                                            placement="bottom"
                                                            overlay={
                                                                <Tooltip className="toltip-popover">
                                                                    <span className="fs-8 text-white fw-semibold">Production Start Time / End Time</span>
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <label className="">Production ST / ET</label>
                                                        </OverlayTrigger></th>
                                                        <th className='min-w-200px'>Description</th>
                                                        <th className='min-w-100px'>Status</th>
                                                        <th className='min-w-100px'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {itemSchedule.map((itemschedule, idx) => (
                                                        <tr key={itemschedule.sno}>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{itemschedule.itemschedule_name}</label>
                                                            </td>
                                                            <td>
                                                                <label className='text-green font-w500 fs-7'>{itemschedule.production_start_time}</label>
                                                                <div className="d-block">
                                                                    <label className="fs-7 text-danger font-w500">{itemschedule.production_end_time}</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{itemschedule.description || "No description available."}</span></Tooltip>} >
                                                                    <div className='text-truncate mw-450px text-black font-w400 fs-7'>{itemschedule.description || "No description available."}
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td>
                                                                <div className="form-check form-switch d-flex align-items-center mb-3">
                                                                    <input
                                                                        className="form-check-input me-2"
                                                                        type="checkbox"
                                                                        role="switch"
                                                                        checked={itemschedule.status == 0}
                                                                        onChange={() => handleStatusChange(itemschedule.sno, itemschedule.status)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <span class="text-end">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1"

                                                                            onClick={() => handleModaleditsch(itemschedule.sno)}
                                                                        >
                                                                            <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                                                            onClick={() => DeleteModal(itemschedule.sno, itemschedule.itemschedule_name)}>

                                                                            <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <Edit
                                                show={editModalShow}
                                                onClose={() => setEditModalShow(false)}
                                                scheduleId={currentItemId}
                                                onUpdated={fetchitemSchedule}
                                            />
                                        </div>
                                    </Col>

                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>

        </>
    )

};

export default ItemSchedule;
